import { LiveWorkoutDataRetriever } from '@src/routes/content/live-workout-data-retriever'

export class LiveWorkoutRetrieverAbstraction {

  static retriever: LiveWorkoutDataRetriever

  static getRetriever (store) {
    if (!this.retriever) {
      this.retriever = new LiveWorkoutDataRetriever(store)
    }
    return this.retriever
  }
}
